import type { ApiResponse } from '@/lib/apiClient';
import { apiClient } from '@/lib/apiClient';
import type { MutationOptions } from '@/lib/reactQuery';
import { useMutation } from '@tanstack/react-query';

interface InitializeForgottenUsernameBody {
  email: string;
}

type InitializeForgottenUsernameResponse = ApiResponse<{
  success: boolean;
}>;

export const initializeForgottenUsername = async ({ email }: InitializeForgottenUsernameBody) => {
  const response = await apiClient.post<InitializeForgottenUsernameResponse>(`/v1/auth/forgotten-username/init`, {
    email,
  });
  return response.data;
};

interface UseInitializeForgottenUsernameOptions {
  email: string;
  options?: MutationOptions<InitializeForgottenUsernameResponse, InitializeForgottenUsernameBody>;
}

export const useInitializeForgottenUsername = ({ options, email }: UseInitializeForgottenUsernameOptions) => {
  return useMutation({
    mutationKey: ['initializeForgottenUsername', email],
    mutationFn: initializeForgottenUsername,
    ...options,
  });
};
